export default "__VITE_ASSET__Bfi$sl75__"